module.exports = __webpack_public_path__ + "static/media/get_connected.453bfdcb.gif";